import React from 'react';

import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';
import { formatAddressComponents } from 'wanderu-utils';

import placeGuideConfig from '../../../../config/placeguide.locale';
import HeroHeader from '../../HeroHeader/HeroHeader';

function PlaceGuideHeader(props) {
    const {
        t,
        backgroundImage,
        travelMode,
        locationData,
        className,
    } = props;
    const {
        placeId: destinationPlaceId,
        name: destinationCity,
        stateCode: destinationState,
        countryCode: destinationCountryShort,
        countryName: destinationCountryLong,
    } = locationData;

    let queries = {};
    if (travelMode === 'flight') {
        queries = { dm: `${travelMode}`, rm: `${travelMode}` };
    }

    const formattedDestinationName = formatAddressComponents(
        destinationCity,
        destinationState,
        destinationCountryShort,
        destinationCountryLong,
    );

    return (
        <HeroHeader
            backgroundImage={backgroundImage}
            className={className}
            title={t('widgetTitle')}
            widgetProps={{
                defaultDestinationPlaceId: destinationPlaceId,
                defaultDestinationInput: formattedDestinationName,
                queries,
            }}
        />
    );
}

PlaceGuideHeader.propTypes = {
    className: PropTypes.string,
    backgroundImage: PropTypes.string.isRequired,
    travelMode: PropTypes.string,
    locationData: PropTypes.shape({
        placeId: PropTypes.string,
        name: PropTypes.string,
        state: PropTypes.string,
        countryCode: PropTypes.string,
        countryName: PropTypes.string,
    }),
};

PlaceGuideHeader.defaultProps = {
    className: '',
    travelMode: '',
    locationData: {},
};

export { PlaceGuideHeader };
export default localize(PlaceGuideHeader, ['t'], placeGuideConfig.namespace);
